import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IconComponent } from '../../icons/icon/icon.component';

@Component({
    selector: 'app-icondialog',
    templateUrl: './icondialog.component.html',
    styleUrls: ['./icondialog.component.scss'],
    imports: [IconComponent],
})
export class IconDialogComponent {
	ref = inject(DynamicDialogRef);
	config = inject(DynamicDialogConfig);

	iconName: string;


	constructor() {
		const config = this.config;

		if (config && config.data) {
			this.iconName = config.data.iconName;
		}
	}
}
